import React, {useState, useRef, useEffect} from "react";
import { filterBy } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridColumnMenuFilter } from "@progress/kendo-react-grid";
import { formatNumber } from "../lib/utils";
import { formatDate } from "@progress/kendo-intl";


const CellRenderer = (schemaItem) => props =>{
    const dataItem = props.dataItem;
    const tooltip = schemaItem.tooltip ? schemaItem.tooltip(dataItem) : undefined;
    const title = dataItem[schemaItem.id];    
    const defaultDateFormat = "yyyy-MM-dd hh:mm";

    let display = title;
    if (schemaItem.dataType == 2)
    {
        let decimalPlaces = schemaItem.decimalPlaces;
        if (decimalPlaces === null || decimalPlaces === undefined)
            decimalPlaces = 2;

        let thousandSeparator = schemaItem.thousandSeparator;
        if (thousandSeparator === null || thousandSeparator === undefined)
            thousandSeparator = "";

        display = formatNumber(title, decimalPlaces, thousandSeparator);
    }

    if (schemaItem.displayRenderer)
        display = schemaItem.displayRenderer(schemaItem, dataItem);


    if ((schemaItem.dataType == 4 || schemaItem.dataType == 5) && display)    
        display = formatDate(display, schemaItem.format ? schemaItem.format : defaultDateFormat );
    
            
    const handleOnCellLinkClick = (e) => {
        if (schemaItem.onCellLinkClick)
            schemaItem.onCellLinkClick(schemaItem, dataItem);
    };

    let className = props.className;
    if (schemaItem.onCellLinkClick)
        className += " is-link";

     return (
        <td className={className} title={tooltip} onClick={handleOnCellLinkClick}>{display}</td>
    )
};


export const MyGrid = props => 
{
    const { id, className, currentTheme, schema, data, onRowDoubleClick, rowStyleHandler,
            isPageable, pageSize,
            isFilterable,
            isSortable,
         ...other } = props;

    const gridRef = useRef(null);

    //managedData
    const [managedData, setManagedData] = useState(data);


    //paging
    const [pagedData, setPagedData] = useState(isPageable ? data.slice(0, pageSize) : data);
    const [skip, setSkip] = useState(0);

    const onPageChange = e =>{
        const skip = e.page.skip;

        setSkip(skip);
        
        setPagedData(managedData.slice(skip, skip + pageSize));
    };


    //filtering
    const [filter, setFilter] = useState([]);
    const onFilterChange = e => {
        //get the filtered and ordered data
        const _data = (e.filter && e.filter.filters && e.filter.filters.length > 0) 
            ? orderBy(filterBy(data, e.filter), sort)
            : orderBy(data, sort);

        //goto first page 
        setSkip(0);

        //set filter
        setFilter(e.filter);

        //set managed data
        setManagedData(_data);

        //set paged data
        if (isPageable)
            setPagedData(_data.slice(0, pageSize));
        else
            setPagedData(_data);
    };
    

    //sorting
    const [sort, setSort] = useState([]);
    const onSortChange = e => {
        //get the filtered and ordered data
        const _data = (filter && filter.filters && filter.filters.length > 0) 
        ? orderBy(filterBy(data, filter), e.sort)
        : orderBy(data, e.sort);
         
        setSort(e.sort);

        setManagedData(_data);

        if (isPageable)
            setPagedData(_data.slice(0, pageSize));
        else
            setPagedData(_data);
    };


    
    const rowRender = (trElement, props) => {
        const rowProps = {
            style:{}
        };

        if (rowStyleHandler)
           rowProps.style = rowStyleHandler(props.dataItem);
        
        if (onRowDoubleClick)
            rowProps.onDoubleClick = e => onRowDoubleClick(props.dataItem);

        return React.cloneElement(
            trElement,
            {
                ...rowProps
            },
            trElement.props.children
        );
    };



    useEffect(() => {
        //recompute
        const _data = (filter && filter.filters && filter.filters.length > 0) 
            ? orderBy(filterBy(data, filter), sort)
            : orderBy(data, sort);

        //goto first page 
        setSkip(0);

        //set managed data
        setManagedData(_data);

        //set paged data
        if (isPageable)
            setPagedData(_data.slice(0, pageSize));
        else
            setPagedData(_data);
    }, [data, isPageable]);


    return (
        <>
            <Grid id={id} className={`my-grid ${className}`}
                data={ pagedData} 
                resizable={true}
                reorderable={true}
                rowRender={rowRender} 
                ref={gridRef}
                pageable={isPageable ? {
                    buttonCount: 4,
                    //pageSizes: [5, 10, 15, "All"],
                    pageSizeValue: pageSize,
                } : false}
                skip={skip} take={pageSize} pageSize={pageSize} total={managedData.length}
                onPageChange={onPageChange}   
                sortable={isSortable ? {
                    allowUnsort: true,
                    mode: "multiple",
                }: false} 
                sort={sort}
                onSortChange={onSortChange}     
                filterable={isFilterable}
                filter={filter}
                onFilterChange={onFilterChange}                                 
            >
            {
                schema.map(item => 
                {
                    if (item.hidden)
                        return undefined;

                    let filterType = "text";
                    
                    if (item.dataType == 1)
                        filterType="boolean";
                    else if (item.dataType == 2)
                        filterType = "numeric";
                    else if (item.dataType == 3)
                        filterType="text";
                    else if (item.dataType == 4 || item.dataType == 5)
                        filterType = "date";                

                    let className = item.className ? item.className : item.id;

                    let format = item.format ? item.format : "";

                    return (<GridColumn key={item.id} field={item.id} title={item.title} 
                        filter={filterType} 
                        className={className} headerClassName={className}  cell={CellRenderer(item)} />)                                                                    
                })            
            }
            </Grid>
            <style>
            {
                `
                    .my-grid .k-pager
                    {
                        display: flex;
                    }

                    .my-grid .is-link
                    {
                        color: ${currentTheme.touchColor};
                        cursor: pointer;
                    }
                `
            }
            </style>
        </>        
    );
};